module.exports = __webpack_public_path__ + "img/projectManagement.b66cd825.svg";